import * as React from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

import muiStyles from './styles';
import { SideBarTileProps } from './types';

const Link = (RouterLink as unknown) as React.ComponentClass<LinkProps>;

const SidebarTile = (props: SideBarTileProps) => {
    const {
        item,
        active,
        count,
        sso
    } = props;
    const classes = muiStyles(props);
    const Icon = item.Icon;

    const baseUrl = React.useMemo(
        () => {
            if (active.includes('/admin') || active.includes('/payments')) {
                return `/${active.split('/')
                    .slice(1, 3)
                    .join('/')}`;
            }

            // Client no longer has /payments root path so only need 1-2 in slice
            return `/${active.split('/')
                .slice(1, 2)
                .join('/')}`;
        },
        [active]
    );

    const isActive = React.useMemo(() => {
        if (item.url === '/admin') {
            return baseUrl === '/admin';
        }

        return baseUrl === item.url;
    }, [ baseUrl, item?.url ]);

    return (
        <Link
            className={`${classes.link} ${isActive ? classes.activeLink : classes.inactiveLink}`}
            to={item.url}
        >
            {
                (item?.notificationsAllowed && sso && count && count > 0) &&
                <div className={`${classes.circle}`}>
                    <p className={`${classes.circleText}`}>{count}</p>
                </div>
            }
            <li className={classes.sidebarTile}>
                {Icon && (
                    <Icon
                        className={`${classes.sidebarIcon} ${
                            isActive ? classes.active : ''
                        }`}
                        iconColor='#888'
                    />
                )}
                <div
                    className={`${classes.name} ${
                        isActive ? classes.active : ''
                    }`}
                >
                    {item.name}
                </div>
            </li>
        </Link>
    );
};

export default SidebarTile;